import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from '../../../../../common/translation/translation.component';

export class ChangePricePlanDetails extends Component {
    constructor(props) {
        super(props);
    }

    renderPlanComponents = props => {
        return props != null && props.length != 0
            ? props.map((item, i) => (
                <tr key={i}>
                    <td>{i === 0 ? <Translation translationKey="plan_details" /> : null}</td>
                    <td>{item.ComponentDetails}</td>
                </tr>
            ))
            : null;
    };

    render() {
        const { data, isWireline } = this.props;
        // Defensive: If data or required nested properties are missing, show fallback UI
        if (!data || !data.Order || !data.Circuit || !data.Subscription || !data.Subscription.PlanDetails || !data.NewRequest || !data.NewRequest.PlanDetails || !data.BusinessJustification) {
            return (
                <div className="alert alert-warning" role="alert">
                    <Translation translationKey="order_details_loading_or_unavailable" />
                </div>
            );
        }
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" /></h4>
                <div className="order-detail-location">
                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data?.Order?.IsRequestedInBehalf} />
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="order_number" /></td>
                                <td>{data.Order.OrderNumber}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.PlanDetails.PlanName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.SimType?.SimTypeName || <Translation translationKey="no_sim_type" />}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="change_plan_to" /></h5>
                    <h5 className="order-detail-location-title"><Translation translationKey="new_price_plan" /></h5>
                    <Table>
                        <tbody className="word-break-all">
                            <tr>
                                <td><Translation translationKey="plan_name" /></td>
                                <td>{data.NewRequest.PlanDetails.PlanName}</td>
                            </tr>
                            {this.renderPlanComponents(data.NewRequest.PlanDetails.PlanType === null ? data.NewRequest.PlanDetails.PlanComponents : data.NewRequest.PlanDetails.PlanComponents.slice(0, 1) )}
                            <tr>
                                <td><Translation translationKey="plan_amount" /></td>
                                <td>{data.NewRequest.PlanDetails.Monthly.toFixed(2)} {data.NewRequest.PlanDetails.Currency.CurrencyName} per month</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        );
    }
}